module.exports = __webpack_public_path__ + "static/3-5bf13b5d4015927081a079d5ff5fdc6d.jpg";